import React, { useState } from 'react';
import { 
  Search, 
  Filter, 
  Wallet,
  TrendingUp,
  Download,
  DollarSign,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

const TeamEWalletReport = () => {
  const [eWalletData, setEWalletData] = useState([
    {
      id: 1,
      memberId: 'AE03814',
      memberName: 'Mr. Henry',
      eWalletBalance: 850,
      totalDeposits: 1500,
      totalWithdrawals: 650,
      lastTransaction: '2026-01-08',
      status: 'active'
    },
    {
      id: 2,
      memberId: 'AE09273',
      memberName: 'Mr. SA',
      eWalletBalance: 1200,
      totalDeposits: 2000,
      totalWithdrawals: 800,
      lastTransaction: '2026-01-08',
      status: 'active'
    },
    {
      id: 3,
      memberId: 'AE19357',
      memberName: 'Mr. Umeshe',
      eWalletBalance: 450,
      totalDeposits: 800,
      totalWithdrawals: 350,
      lastTransaction: '2026-01-07',
      status: 'active'
    },
    {
      id: 4,
      memberId: 'AE23363',
      memberName: 'Mr. Hendry',
      eWalletBalance: 3200,
      totalDeposits: 5000,
      totalWithdrawals: 1800,
      lastTransaction: '2026-01-07',
      status: 'active'
    },
    {
      id: 5,
      memberId: 'AE24335',
      memberName: 'Mr. Sheshappe',
      eWalletBalance: 150,
      totalDeposits: 500,
      totalWithdrawals: 350,
      lastTransaction: '2026-01-06',
      status: 'inactive'
    }
  ]);

  const [filters, setFilters] = useState({
    search: '',
    status: 'all'
  });

  const [sortConfig, setSortConfig] = useState({ key: 'eWalletBalance', direction: 'desc' });

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const filteredData = eWalletData.filter(item => {
    return (
      (!filters.search || 
       item.memberId.toLowerCase().includes(filters.search.toLowerCase()) ||
       item.memberName.toLowerCase().includes(filters.search.toLowerCase())) &&
      (filters.status === 'all' || item.status === filters.status)
    );
  });

  filteredData.sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) return sortConfig.direction === 'asc' ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key]) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const totalBalance = eWalletData.reduce((sum, item) => sum + item.eWalletBalance, 0);
  const totalDeposits = eWalletData.reduce((sum, item) => sum + item.totalDeposits, 0);
  const totalWithdrawals = eWalletData.reduce((sum, item) => sum + item.totalWithdrawals, 0);

  const exportToCSV = () => {
    alert('Export functionality would be implemented here');
  };

  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />;
  };

  return (
    <div className="max-w-7xl mx-auto pt-10 px-4">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gold-100">Team E-Wallet Report</h1>
        <p className="text-gold-400">View team electronic wallet balances and transactions</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="bg-gold-900/30 border border-gold-600/50 rounded-2xl p-6">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-full bg-green-500/20 flex items-center justify-center mr-4">
              <Wallet className="h-6 w-6 text-green-400" />
            </div>
            <div>
              <div className="text-green-400 text-sm mb-1">Total E-Wallet Balance</div>
              <div className="text-3xl font-bold text-green-300">${totalBalance.toLocaleString()}</div>
            </div>
          </div>
        </div>

        <div className="bg-gold-900/30 border border-gold-600/50 rounded-2xl p-6">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mr-4">
              <TrendingUp className="h-6 w-6 text-blue-400" />
            </div>
            <div>
              <div className="text-blue-400 text-sm mb-1">Total Deposits</div>
              <div className="text-3xl font-bold text-blue-300">${totalDeposits.toLocaleString()}</div>
            </div>
          </div>
        </div>

        <div className="bg-gold-900/30 border border-gold-600/50 rounded-2xl p-6">
          <div className="flex items-center">
            <div className="w-12 h-12 rounded-full bg-red-500/20 flex items-center justify-center mr-4">
              <DollarSign className="h-6 w-6 text-red-400" />
            </div>
            <div>
              <div className="text-red-400 text-sm mb-1">Total Withdrawals</div>
              <div className="text-3xl font-bold text-red-300">${totalWithdrawals.toLocaleString()}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="bg-gold-900/30 border border-gold-600/50 rounded-2xl p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="relative">
            <input
              type="text"
              name="search"
              value={filters.search}
              onChange={handleFilterChange}
              placeholder="Search by member ID or name"
              className="w-full pl-10 pr-4 py-3 bg-gold-900/50 border border-gold-600/50 rounded-xl text-gold-100 placeholder-gold-600 focus:outline-none focus:border-gold-500"
            />
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gold-500" />
          </div>

          <div>
            <select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full px-4 py-3 bg-gold-900/50 border border-gold-600/50 rounded-xl text-gold-100 focus:outline-none focus:border-gold-500"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="flex items-end">
            <button
              onClick={exportToCSV}
              className="w-full flex items-center justify-center px-4 py-3 bg-gold-500 hover:bg-gold-400 text-black font-semibold rounded-xl transition-all"
            >
              <Download className="h-5 w-5 mr-2" />
              Export Report
            </button>
          </div>
        </div>
      </div>

      {/* E-Wallet Report Table */}
      <div className="bg-gold-900/30 border border-gold-600/50 rounded-2xl overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gold-900/50">
              <tr>
                <th className="py-4 px-6 text-left text-gold-300 font-semibold">Member ID</th>
                <th className="py-4 px-6 text-left text-gold-300 font-semibold">Member Name</th>
                <th 
                  className="py-4 px-6 text-left cursor-pointer hover:bg-gold-800/50"
                  onClick={() => handleSort('eWalletBalance')}
                >
                  <div className="flex items-center text-gold-300 font-semibold">
                    E-Wallet Balance
                    {getSortIcon('eWalletBalance')}
                  </div>
                </th>
                <th 
                  className="py-4 px-6 text-left cursor-pointer hover:bg-gold-800/50"
                  onClick={() => handleSort('totalDeposits')}
                >
                  <div className="flex items-center text-gold-300 font-semibold">
                    Total Deposits
                    {getSortIcon('totalDeposits')}
                  </div>
                </th>
                <th 
                  className="py-4 px-6 text-left cursor-pointer hover:bg-gold-800/50"
                  onClick={() => handleSort('totalWithdrawals')}
                >
                  <div className="flex items-center text-gold-300 font-semibold">
                    Total Withdrawals
                    {getSortIcon('totalWithdrawals')}
                  </div>
                </th>
                <th className="py-4 px-6 text-left text-gold-300 font-semibold">Last Transaction</th>
                <th className="py-4 px-6 text-left text-gold-300 font-semibold">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gold-800/50">
              {filteredData.map(item => (
                <tr key={item.id} className="hover:bg-gold-900/20 transition-colors">
                  <td className="py-4 px-6">
                    <div className="font-mono text-gold-100">{item.memberId}</div>
                  </td>
                  <td className="py-4 px-6 text-gold-100">{item.memberName}</td>
                  <td className="py-4 px-6">
                    <div className="font-bold text-green-400">${item.eWalletBalance.toLocaleString()}</div>
                  </td>
                  <td className="py-4 px-6">
                    <div className="text-blue-400">${item.totalDeposits.toLocaleString()}</div>
                  </td>
                  <td className="py-4 px-6">
                    <div className="text-red-400">${item.totalWithdrawals.toLocaleString()}</div>
                  </td>
                  <td className="py-4 px-6 text-gold-300">{item.lastTransaction}</td>
                  <td className="py-4 px-6">
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs ${
                      item.status === 'active' 
                        ? 'bg-green-500/20 text-green-400' 
                        : 'bg-red-500/20 text-red-400'
                    }`}>
                      {item.status === 'active' ? 'Active' : 'Inactive'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredData.length === 0 && (
            <div className="text-center py-16">
              <div className="text-gold-500 text-6xl mb-4">💳</div>
              <p className="text-gold-400">No e-wallet data found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TeamEWalletReport;